import React from "react";
import img1 from "../assets/img/bandeau.jpg";
import { Row, Col } from "react-bootstrap";

export const NouveauLivre = () => {
  return (
    <div className="auteure-container">
      <div className="banner-titre-container">
        <img src={img1} className="back-img" alt="" />
        <div className="over-banner">
          <div className="info-banner">
            <h1 className="banner-title">Mon nouveau livre</h1>
          </div>
        </div>
      </div>

      <br />
      <br />
      <div className="contianer-videos-livre">
        <Row className="mt-5 g-4 justify-content-center">
          <Col xs={12} lg={6}>
            <iframe
              width="100%"
              height="350"
              src="https://www.youtube.com/embed/KS7Gr2Yj-R8"
              title="Vidéo 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Col>

          <Col xs={12} lg={6}>
            <iframe
              width="100%"
              height="350"
              src="https://www.youtube.com/embed/A7oJZ2hH1Ng"
              title="Vidéo 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Col>
        </Row>
      </div>
    </div>
  );
};
